import { YupSchema } from 'services/yup/types'
import { yupArray } from 'services/yup'
import {
  ProductPackage,
  ProductPresetWithUpselling,
} from 'services/api/entities/catalog/packages/common'
import { baseProductPackageVS, baseProductPresetVS } from './baseProductPackage'

export const productWithUpsellingPresetVS: YupSchema<ProductPresetWithUpselling> =
  baseProductPresetVS.shape({
    upselling: yupArray(baseProductPresetVS),
  })

export const productWithUpsellingPackageVS: YupSchema<
  ProductPackage<ProductPresetWithUpselling>
> = baseProductPackageVS.shape({
  products: yupArray(productWithUpsellingPresetVS).min(1),
})
